<div class="modal-header primary">

    <h5 class="modal-title primary">{{_title}}</h5>

</div>
<div class="modal-body- p-4">


    <form class="form-horizontal" [formGroup]="insertForm" (ngSubmit)="onInsertSubmit()" name="cuForm" autocomplete="off">


        <div class="row">

            <div class="col-12">
                <label class="text-second">Title:</label>
                <mat-select formControlName="courseTitle" #select (selectionChange)="populateTitleData($event)"
                            class="form-control no-radius">
                    <mat-option *ngFor="let title of titlesList" [value]="title">{{title.title}}</mat-option>
                </mat-select>
            </div>

          
            <div class="col-12">

                <label class="text-second">
                    Course Description:
                </label>
                <textarea class="form-control no-radius" formControlName="description" placeholder="10,000 Characters Limit" maxlength="10000" rows="5"></textarea>
            </div>
            <div class="col-12">

                <label class="text-second">
                    Key points:
                </label>
                <textarea class="form-control no-radius" formControlName="keyPoints" placeholder="10,000 Characters Limit" maxlength="10000" rows="5"></textarea>
            </div>
        </div>


        <div class="row">
        </div>

        <div class="modal-footer">
            <!--(click)="close.emit()"-->
            <button type="button" class="book-btn" (click)="activeModal.close('Close click')">
                Cancel
            </button>

            <div class="">
                <button [disabled]="!insertForm.valid"
                        class="book-btn">
                    Save
                </button>

            </div>
        </div>
    </form>
</div>